import 'underscore';

function validate(textWithHtml) {
    var elm = document.createElement('div');
    elm.innerHTML = textWithHtml || '';
    if (elm.textContent) {
        return elm.textContent.trim() !== '' ? null : 'Beskrivning saknas';
    } else if (elm.innerText) {
        return elm.innerText.trim() !== '' ? null : 'Beskrivning saknas';
    }
    return 'Beskrivning saknas';
}

// By ensuring that shortDescription is always a string makes
// it easy to know when it has really changed to something significant.
function ensureString(s) {
    return !s ? '' : s;
}

var initialState = {
    longDescription: null,
    validationError: null,
    isCurrentDescriptionFromDraft: false,
    fromDraftCounter: 0
};

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_LONG_DESCRIPTION_FROM_DRAFT':
            return _.assign({}, state, {
                isCurrentDescriptionFromDraft: true,
                longDescription: ensureString(action.payload),
                validationError: validate(action.payload),
                fromDraftCounter: state.fromDraftCounter + 1
            });
        case 'SET_LONG_DESCRIPTION':
            return _.assign({}, state, {
                isCurrentDescriptionFromDraft: false,
                longDescription: ensureString(action.payload),
                validationError: validate(action.payload)
            });
        case 'RESET_LONG_DESCRIPTION': {
            const defaultValue = null;
            return _.assign({}, state, {
                isCurrentDescriptionFromDraft: false,
                longDescription: defaultValue,
                validationError: validate(defaultValue)
            });
        }
        default:
            return state;
    }
};
